<template>
  <WsCreate
    :modelName="modelName"
    :submodelName="submodelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="act"
    parentLabel="法規"
    parentTitleKey="last_version.name"
    :parentId="$route.params.id"
    :itemDeletable="itemDeletable"
    :itemEditable="itemEditable"
    :itemLinkCheckable="itemLinkCheckable"
    :itemVersionCreatable="itemVersionCreatable"
    @fetch-parent-model-data="$_fetchActData($event)"
  >
  </WsCreate>
</template>

<script>
import actModel from "@/models/act";
import submodel from "@/models/article";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄更新法律版本嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data() {
    return {
      modelName: "act_version",
      submodelName: submodel.versionModelName,
      label: "法規版本",
      fields: actModel.fields.last_version.fields,
      itemDeletable: true,
      itemEditable: false,
      itemLinkCheckable: false,
      itemVersionCreatable: true,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "法規內容",
                fields: ["locales", "announce_at", "effect_at", "reference_link", "attaches"],
              },
            ],
          },
          {
            type: "expandList",
            label: submodel.label,
            modelName: submodel.versionModelName,
            modeParent: true,
            modeVersions: true,
            modeParentVersions: true,
            fields: submodel.fields.last_version.fields,
            titleKey: "no_text",
            fieldsRead: [
              "locales",
              "announce_at",
              "effect_at",
              "attaches",
              "effects",
            ],
            batchMode: true,
            searchMode: false,
            orderBy: "no_number",
            orderWay: "asc",
            hideOnNull: false,
            groupSaving: true,
            articleSaving: true,
            getUrl: () => {
              return 'article_version'
            },
            customSubmitModelDatasAction: (rawModelDatas) => {
              this.allArticleVersionIds.map(versionId => {
                const tarArticleVersion = rawModelDatas.find(rawData => rawData.id === versionId.id);
                if (!tarArticleVersion) rawModelDatas.push(versionId);
              })
              return rawModelDatas;
            },
          },
        ],
        secondary: [],
        allArticleVersionIds: [],
      },
    }
  },
  methods: {
    async $_getAllArticleVersionIds(actVersionId) {
      const res = await this.$axios.get('article_version/id/index/all', {
        params: {
          get_all: 1,
          act_versions: actVersionId,
        }
      });
      this.allArticleVersionIds = res.data.data.map(_data => _data);
    },
    async $_fetchActData(act) {
      const actVersionId = act.last_version.id;
      await this.$_getAllArticleVersionIds(actVersionId);
    }
  }
};
</script>